import errors from './errors/index.js';
import translation from './translation/index.js';
const zhTW = Object.freeze({
    translation,
    errors,
});
export default zhTW;
